/**
 * Search element for ReactVirtualSelector.
 * @author artisan.
 * @Date(2015-11-08)
 */

import React from 'react';
import _ from 'underscore';
import classnames from 'classnames';

class SelectorFilter extends React.Component {
  
  constructor(props) {
    super(props);
    
    /**
     * Component display in react develop tool.
     * 
     * @type {String}
     */
    this.displayName = 'SelectorFilter';
  }

  /**
   * On change event.
   * 
   * @param  {object} event event.
   * @return {undefind}
   */
  handleChange(event) {
    let { onChange } = this.props;

    if ( _.isFunction(onChange) ) {
      onChange(event.target.value);
    }
  }

  render() {
    return (
      <div className={ classnames('selector-searchable', this.props.className) }>
        <input type="text" className="selector-filter" ref="input" autoFocus={ this.props.autoFocus } onChange={ this.handleChange.bind(this) } defaultValue={ this.props.value } />
      </div>
    );
  }
}

/**
 * Define default properties.
 * 
 * @type {Object}
 */
SelectorFilter.defaultProps = {
  value: '',
  onChange: null,
  className: '',
  autoFocus: false
};

/**
 * Define property types.
 * 
 * @type {Object}
 */
SelectorFilter.propTypes = {
  value: React.PropTypes.string,
  onChange: React.PropTypes.func,
  className: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.object
  ]),
  autoFocus: React.PropTypes.bool
};

export default SelectorFilter;



/** WEBPACK FOOTER **
 ** ./src/javascript/components/SelectorFilter.jsx
 **/